import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVimeolivestreamComponent } from './simple-icons-vimeolivestream.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVimeolivestreamComponent ],
    exports:      [ SimpleIconsVimeolivestreamComponent ],
    bootstrap:    []
})
export class SimpleIconsVimeolivestreamModule {}
